import { useAuthentication } from '@/hooks/useAuthentication';
import { HomePage } from '@edwin-group/cj-graphql';

export const Header = ({ page }: { page: HomePage | null }) => {
  const { authentication } = useAuthentication();
  return (
    <>
      <div className="flex flex-col justify-between gap-sh-15 lg:flex-row">
        <div className="w-full">
          <h1 className=" mb-sh-15 font-cadiz text-sh-28-32 font-bold">
            Hello, {authentication?.user?.forename || 'Guest'}
          </h1>
          <p className="font-cadiz text-sh-16-24">{page?.headerSection.message}</p>
        </div>
      </div>
    </>
  );
};
